import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "staticBackdropLabel"
  }, "Inloggning"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_6 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_login_form = _resolveComponent("login-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.authed())
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.type === 'button')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showForm && _ctx.showForm(...args)))
              }, " Inloggning "))
            : _createCommentVNode("", true),
          (_ctx.type === 'link')
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: "#",
                class: "nav-link",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showForm && _ctx.showForm(...args)))
              }, "Inloggning"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "modal fade",
      id: _ctx.state.id,
      tabindex: "-1",
      "aria-labelledby": "staticBackdropLabel",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_login_form, { title: "" })
          ])
        ])
      ])
    ], 8, _hoisted_2)
  ], 64))
}